document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('submit', function (event) {
        if (!event.target.matches('#contact-form')) return;
        event.preventDefault();

        const form = event.target;
        const formContainer = form.closest('.js-contact-form');
        const params = new URLSearchParams(new FormData(form));
        params.append('action', 'submit-contact-ajax');
        params.append('nonce', variables.contact_nonce);

        fetch(urls.ajax, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: params,
        })
            .then(r => r.json())
            .then(response => {
                if (!formContainer) return;
                formContainer.innerHTML = response.data.form;
                const messageEl = formContainer.querySelector('.form__success, .form__error');
                if (messageEl) messageEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            })
            .catch(() => {});
    });
});
